enum LocationValidationState {
  VALIDATE_ON_MOUNT = 'validateOnMount',
  VALIDATION_LEVEL = 'validationLevel',
}

export default LocationValidationState
